import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import titleMixin from '@/mixins/titleMixin';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/app.scss';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import '@/assets/css/font-awesome.css';
import '@/assets/css/linearicon.css';
import '@/assets/css/vendors/font-awesome.css';
import vueFeather from 'vue-feather';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueApexCharts from 'vue3-apexcharts';
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(CKEditor);
app.component('vueFeather', vueFeather);
app.component('apexchart', VueApexCharts);
app.mixin(titleMixin);
app.use(router);
app.mount('#app');
